import { Component, OnInit } from '@angular/core';
import { AlertService } from 'src/app/services/alert.service';
import { PreCheckoutService } from 'src/app/services/pre-checkout.service';
import { Utilitarios } from 'src/app/shared/utilitarios';
import { PreCheckoutQuery } from 'src/app/state/pre-checkout.query';
import { PreCheckoutVeiculoService, ValuesVeiculo } from '../pre-checkout-veiculo.service';

@Component({
  selector: 'app-pre-checkout-veiculo-alvo-origem',
  templateUrl: './pre-checkout-veiculo-alvo-origem.component.html',
  styleUrls: ['./pre-checkout-veiculo-alvo-origem.component.css']
})
export class PreCheckoutVeiculoAlvoOrigemComponent implements OnInit {

  message: string = "Verificar checkout do alvo de origem";
  color: string = "text-primary";
  sm: number;
  cpf: string = null;
  usuarioBloqueado: boolean = false;
  showProsseguir: boolean = false;
  scheduler: any;
  schedulerAlvoOrigem: any;
  
  constructor(
    private alertService: AlertService,
    private preCheckoutService: PreCheckoutService,
    private preCheckoutQuery: PreCheckoutQuery,
    private veiculoService: PreCheckoutVeiculoService
  ) { }

  ngOnInit(): void {
    //Limpa mensagem ao iniciar o componente
    this.alertService.limpaAlertMessage();

    this.schedulerBloqueio();

    this.preCheckoutQuery.sm$.subscribe((sm)=>{
      this.sm = sm == null ? 0 : parseInt(sm);
    });

    this.preCheckoutQuery.cpf$.subscribe((cpf)=>{
      this.cpf = cpf;
    });

    this.verificar();
    this.schedulerVerificaAlvoOrigem();
  }

  GetAlvoOrigem(callBack1: any = null, callBack2: any = null){
    this.preCheckoutService.GetAlvoOrigem(this.sm)
    .subscribe(
      (result) => {
        if(result)
        {
          if(callBack1)
            callBack1(result);
        }
        else{
          if(callBack2)
            callBack2();
        }
      },
      (err) => {
        this.alertService.alertDanger(err || "Ocorreu um erro ao tentar consultar alvo origem do veículo, tente novamente!", null);
      }
    );
  }

  bloquearMotorista(){
    this.preCheckoutService.bloquearMotorista(this.cpf)
      .subscribe(
        (result) => {
          if(result){
            let message = "Você excedeu o limite máximo de 3 tentativas!\n";
            message+="Pré-checkout reprovado!";
            this.alertService.alertWarning(message, null);
            this.usuarioBloqueado = true;
          }
        },
        (err) => {
          this.alertService.alertDanger("Ocorreu um erro ao tentar realizar bloqueio, tente novamente!", null);
        }
      );
  }

  schedulerBloqueio(){
    //Após 30 minutos bloqueia o motorista caso o sinal não seja detectado
    this.scheduler = setTimeout(function(){ 
      console.log("setTimeout: Bloqueando motorista após 30 minutos");
      this.bloquearMotorista();
    }.bind(this), 1800000);
  }

  //Verifica se o veículo está com sinal a cada 1 minuto
  schedulerVerificaAlvoOrigem(){
    console.log("setInterval: Consultando sinal a cada 1 minuto");
    this.schedulerAlvoOrigem = setInterval(() => {
      this.verificar();
    }, 60000);
  }

  verificar(){
    this.GetAlvoOrigem(function(){
      this.alertService.limpaAlertMessage();
      this.showProsseguir = true;
      this.message = "Veículo confirmado dentro do alvo origem com sucesso!";
      this.color = "text-success";

      if (this.scheduler)
        clearTimeout(this.scheduler);

      if (this.schedulerAlvoOrigem)
        clearInterval(this.schedulerAlvoOrigem);

      setTimeout(function(){ 
        //Após 5 segundos redireciona para a próxima verificação
        this.prosseguir();
      }.bind(this), 5000);

    }.bind(this), function(){
      this.message = "Veículo fora do alvo origem, favor movimentar o veículo!";
      this.color = "text-danger";
    }.bind(this));
  }

  prosseguir(){
    this.veiculoService.setValue(new ValuesVeiculo(false, false, false, false, false, true));
  }
}